<template>
  <div>
    <div class="content5Block" v-if="!trainDetail">
      <div class="content5Text1">2026年线下培训</div>
      <div class="content5Text2">报名后以实际通知时间为准，点击按钮查看详细课程安排</div>
      <div class="content5Line"></div>
      <div class="content5List">
        <div class="listTitle">
          <div class="listBlock1" style="font-size: 18px;top: 2px;">计划时间</div>
          <div class="listBlock2" style="font-size: 18px;top: 2px;color:#FFFFFF;">培训地点</div>
          <div class="listBlock3" style="font-size: 18px;top: 2px;">培训类型</div>
          <div class="listBlock4" style="font-size: 18px;top: 2px;">培训时长</div>
          <div class="listBlock5" style="font-size: 18px;top: 2px;">报名状态</div>
        </div>
        <div style="margin-top: 36px;"></div>
        <div class="listBlock" v-for="(item, index) in trainCampList" :key= "'trainCampList'+index" :style="index == trainCampList.length-1? 'margin-bottom:0px':''">
            <div class="listBlock1">{{ item.date }}</div>
            <div class="listBlock2">{{ item.region }}</div>
            <div class="listBlock3">{{ item.name }}</div>
            <div class="listBlock4">{{ item.duration }}天</div>
            <div class="listBlock5">
              <span v-if="item.trainStatus=='预约报名中'">现可预约报名</span>
              <span v-else-if="item.trainStatus=='火热报名中'">火热报名中</span>
              <span v-else-if="item.trainStatus=='限量报名中'">限量报名中</span>
              <span v-else style="color: #777;">{{ item.trainStatus }}</span>
            </div>
        </div>
      </div>
      <div class="content5Button" @click="$emit('show-detail')" style="left: calc(50% - 210px);width: 150px;">查看详细课程安排</div>
      <div class="content5Button" @click="handleSign">{{ hasSignedIn ? '查看报名结果' : '立即报名' }}</div>
    </div>
    <div class="content5Block1" v-if="trainDetail">
      <div class="content5Block1Back" @click="$emit('hide-detail')">&lt; 返回</div>
      <div class="content5Block1Title">吉林一号遥感开发者培训班 - 课程安排</div>
      <div class="content5Block1Tabs">
        <div
          v-for="item in trainCampList"
          :key="'campTab' + item.qs"
          class="content5Block1Tab"
          :class="{ active: activeQs === item.qs }"
          @click="activeQs = item.qs"
        >{{ item.region }}</div>
      </div>
      <div class="content5Block1Image">
        <img
          v-if="currentCamp && currentCamp.courseImageUrl"
          :src="currentCamp.courseImageUrl"
          :alt="currentCamp.region"
        >
        <div v-else class="content5Block1ImagePlaceholder">暂无课程安排图片</div>
      </div>
      <div class="content5Block1SignIn" @click="handleDetailSign">{{ currentCampSignedIn ? '查看报名结果' : '立即报名' }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrainSchedule",
  props: {
    // 用于 content5Block1(培训课程表背景)与 content5Block 之间切换
    trainDetail: { type: Boolean, default: false },
    trainCampList: { type: Array, default: () => [] }
  },
  data() {
    return {
      // 当前选中城市的期数 qs(取自 trainCampList[i].qs),用于 content5Block1 中切换不同课程的图片
      activeQs: null
    }
  },
  watch: {
    // 列表到达/变更后,默认选中中间的长春(qs 14),取不到再回退第一项
    trainCampList: {
      immediate: true,
      handler(list) {
        if (list && list.length && (this.activeQs == null || !list.some(it => it.qs === this.activeQs))) {
          const changchun = list.find(it => it.qs === 14) || list[0]
          this.activeQs = changchun.qs
        }
      }
    }
  },
  computed: {
    // 当前选中(activeQs)对应的 trainCampList 项,用于显示对应城市的课程图片
    currentCamp() {
      if (this.activeQs == null) return null
      return this.trainCampList.find(item => item.qs === this.activeQs) || null
    },
    // 列表页按钮:遍历整个列表,只要存在任意一期已报名(报名状态 != '未报名'),即显示「查看报名结果」
    hasSignedIn() {
      return (this.trainCampList || []).some(camp => camp.signInStatus !== '未报名')
    },
    // 详情页按钮:根据当前选中 qs 的报名状态动态显示
    currentCampSignedIn() {
      const camp = this.currentCamp
      if (!camp) return false
      return camp.signInStatus !== '未报名'
    }
  },
  methods: {
    // 已报名 → 进入报名结果页;否则走报名流程
    handleSign() {
      if (this.hasSignedIn) {
        this.$emit('go-result')
      } else {
        this.$emit('sign-in')
      }
    },
    // 查看详细课程安排(内容5区块1)内的按钮:根据当前选中期数的报名状态,已报名 → 报名结果页;否则携带当前期数 qs 跳转报名页
    handleDetailSign() {
      if (this.currentCampSignedIn) {
        this.$emit('go-result')
      } else {
        this.$emit('detail-sign-in', this.activeQs)
      }
    }
  }
}
</script>

<style scoped>
.content5Block{
  position: relative;
  width: 1280px;
  height: 716px;
  background: #141B2C;
  border-radius: 16px;
}
.content5Block1{
  position: relative;
  width: 1280px;
  height: 716px;
  background: #141B2C;
  border-radius: 16px;
}
.content5Block1Title{
  position: absolute;
  top: 40px;
  left: 0;
  width: 1280px;
  height: 28px;
  font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
  font-weight: 300;
  font-size: 26px;
  color: #FFFFFF;
  line-height: 28px;
  text-align: center;
}
.content5Block1Tabs{
  position: absolute;
  top: 95px;
  left: 0;
  width: 1280px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 90px;
}
.content5Block1Tab{
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 28px;
  cursor: pointer;
  opacity: 0.85;
}
.content5Block1Tab.active{
  color: #2A8CFF;
  opacity: 1;
  font-weight: 500;
}
.content5Block1Back{
  position: absolute;
  top: 40px;
  left: 40px;
  z-index: 2;
  padding: 4px 12px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  user-select: none;
}
.content5Block1Back:hover{
  color: #FFFFFF;
}
.content5Block1Image{
  position: absolute;
  top: 140px;
  left: 60px;
  width: 1160px;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.content5Block1Image img{
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  pointer-events: none;
}
.content5Block1ImagePlaceholder{
  font-family: PingFangSC, PingFang SC;
  font-weight: 300;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}
.content5Block1SignIn{
  position: absolute;
  bottom: 26px;
  left: 50%;
  transform: translateX(-50%);
  width: 150px;
  height: 44px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid #FFFFFF;
  border-radius: 27px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
.content5Block1SignIn:hover{
  background: rgba(255, 255, 255, 0.22);
}
.content5Block1Btn1{
  position: absolute;
  width: 50px;
  height: 17px;
  top:50px;
  left:50px;
  cursor: pointer;
}
.content5Block1Btn2{
  position: absolute;
  top: 645px;
  left: calc(50% - 64px);
  width: 128px;
  height: 44px;
  cursor: pointer;
}
.content5Text1{
  position: absolute;
  top: 81px;
  left: calc(50% - 640px);
  width: 1280px;
  height: 28px;
  font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
  font-weight: 300;
  font-size: 26px;
  color: #FFFFFF;
  line-height: 28px;
  text-align: center;
}
.content5Text2{
  position: absolute;
  top: 129px;
  left: calc(50% - 640px);
  width: 1280px;
  height: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 300;
  font-size: 14px;
  color: #CCCCCC;
  line-height: 16px;
  text-align: center;
}
.content5Line{
  position: absolute;
  top: 185px;
  left: 200px;
  width: 880px;
  height: 1px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.content5List{
  position: absolute;
  top: 225px;
  left: 200px;
  width: 880px;
  height: 350px
}
.listTitle{
  position: relative;
  margin-top: 0;
  margin-left: 0;
  width: 880px;
  height: 20px;
}
.listBlock{
  position: relative;
  margin-bottom: 29px;
  width: 880px;
  height: 16px;
}
.listBlock1{
  position: absolute;
  width: 155px;
  height: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 16px;
  text-align: center;
}
.listBlock2{
  position: absolute;
  left: 160px;
  width: 160px;
  height: 16px;
  font-family:PingFangSC, PingFang SC;
  font-weight: normal;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 16px;
  text-align: center;
}
.listBlock3{
  position: absolute;
  left: 320px;
  width: 300px;
  height: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: normal;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 16px;
  text-align: center;
}
.listBlock4{
  position: absolute;
  left:620px;
  width: 190px;
  height: 16px;
font-family: PingFangSC, PingFang SC;
font-weight: normal;
font-size: 16px;
color: #FFFFFF;
line-height: 16px;
text-align: center;
}
.listBlock5{
  position: absolute;
  left: 825px;
  width: 85px;
  height: 16px;
  font-family:PingFangSC, PingFang SC;
  font-weight: normal;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 16px;
  text-align: center;
}
.content5Button{
  position: absolute;
  top: 620px;
  left: calc(50% + 60px);
  width: 150px;
  height: 44px;
  background: rgba(255,255,255,0.15);
  border-radius: 27px;
  border: 1px solid #FFFFFF;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
</style>
